// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bddd33d4","644":"f779a879"}[chunkId] + ".chunk.js";
};